
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/[postId]",
      function () {
        return require("private-next-pages/posts/[postId].tsx");
      }
    ]);
  